const noBidReasonOptions = [
  {
    label: "Insufficient Resources",
    value: "insufficientResources",
  },
  {
    label: "Technical Incompatibility",
    value: "technicalIncompatibility",
  },
  {
    label: "Competitive Reasons",
    value: "competitiveReasons",
  },
  {
    label: "Others",
    value: "others",
  },
];
export default noBidReasonOptions;
